// initialize state
const initState = () => ({
  releCrmContactId: ""
})

const state = initState()

// getters
const getters = {
  /**
   * Get rele crm contact id
   * @param {object} state - current state
   */
  getReleCrmContactId(state) {
    return state.releCrmContactId
  }
}

// mutations
const mutations = {
  /**
   * Set rele crm contact id
   * @param {object} state - current state
   * @param {*} payload - new value
   */
  setReleCrmContactId(state, payload) {
    state.releCrmContactId = payload
  },

  /**
   * Reset the auth state.
   *
   * @param {object} state - Current state.
   */
  reset(state) {
    // get initial state
    const newState = initState()
    Object.entries(newState).forEach(([key, value]) => {
      state[key] = value
    })
  }
}

// actions
const actions = {}

// export module
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
